import type { CampaignGame } from '@/services/api/types';

const MS_IN_DAY = 24 * 60 * 60 * 1e3;

export default (game: CampaignGame) => {
  if (!game) return 0;
  const start = new Date(new Date(game.startTime ?? 0).toISOString()).getTime();
  const now = new Date(new Date().toISOString()).getTime();
  return Math.ceil((now - start) / MS_IN_DAY / 7);
};
